import { StoreState } from '../store-interfaces';
import { createSelector } from 'reselect';
import { activeFacebookPageIdSelector } from './viewSelectors';
import { XrayConfigurationPayload } from '../interfaces/xrayConfiguration';

export const selectXRayConfigs = (state: StoreState) =>
  state.xrayConfigurations.entities || [];

export const selectXRayConfig = createSelector(
  [selectXRayConfigs, activeFacebookPageIdSelector],
  (configs, facebookPageId) =>
    configs?.find(v => v.facebookPageId === facebookPageId),
);

export const hasConfiguredEvents = (config?: XrayConfigurationPayload) =>
  Object.values(config?.configurations || {}).some(Boolean);
export const hasConfiguredFb = (config?: XrayConfigurationPayload) =>
  [config?.accessToken, config?.pixelId].every(Boolean);

export const hasConfiguredIntegrations = (config?: XrayConfigurationPayload) =>
  config?.mode === 'integrations';
